import { render, staticRenderFns } from "./StatInput.vue?vue&type=template&id=38f053c3&"
import script from "./StatInput.vue?vue&type=script&lang=js&"
export * from "./StatInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports